import React, { useEffect, useRef } from "react";
import * as echarts from "echarts";
import { isDebug } from "../../../../../utils";
import _ from 'lodash';


export const AromaPotentialGraph = ({ dataAnalysisInfo }) => {
  const chartRef = useRef(null);
  const myChart = useRef(null);
  useEffect(() => {
    if (chartRef.current && !myChart.current) {
      myChart.current = echarts.init(chartRef.current);
    }
    const categories = [
      "Sucrose",
      "Mono\nsugar",
      "Diterpene",
      "Trigonelline",
      "Organic\nacids",
      "Chlorogenic\nacids",
    ];
    const values = [
      dataAnalysisInfo.ChlorogenicAcids,
      dataAnalysisInfo.Sucrose,
      dataAnalysisInfo.MonoSugar,
      dataAnalysisInfo.Diterpene,
      dataAnalysisInfo.Trigonelline,
      dataAnalysisInfo.OrganicAcids,
    ];
    if (isDebug()) console.log("## values", values);
    
    const option = {
      title: {
        text: "{icon|} Aroma Potential",
        textStyle: {
          color: "#131213",
          rich: {
            icon: {
              height: 20,
              width: 20,
              align: "left",
              backgroundColor: {
                image: 'data:image/png;base64,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',
              }
            },
          },
        },
      },
      polar: {
        radius: [22, "68%"],
      },
      radiusAxis: {
        max: 1,
      },
      angleAxis: {
        type: "category",
        data: categories,
        startAngle: 90,
        axisLine: {
          show: true,
          lineStyle: {
            color: "#ddd",
            width: 1,
            type: "solid",
          },
        },
        axisLabel: {
          color: "#333",
          fontSize: "11",
          verticalAlign: "top",
          align: "right",
        },
      },
      tooltip: {},
      series: [
        {
          type: "bar",

          data: values,
          coordinateSystem: "polar",

          itemStyle: {
            color: (params) => {
              const colors = [
                "rgba(60, 87, 102, 0.915)",
                "rgba(134, 120, 81, 0.915)",
                "rgba(193, 146, 65, 0.915)",
                "rgba(252, 150, 82, 0.915)",
                "rgba(199, 75, 89, 0.915)",
                "rgba(199, 75, 89, 0.915)",
              ];
              return colors[params.dataIndex];
            },
          },
        },
      ],
      animation: false,
    };

    if (myChart.current) {
      myChart.current.setOption(option);
    }
            
            
    // 창크기 변경할때 카트를 갱신한다.
    const handleResize = _.debounce(() => {
        myChart.current?.resize();
    }, 50); // Debounce for 50ms

    window.addEventListener('resize', handleResize);

    return () => {
        try {
            window.removeEventListener('resize', handleResize);
        
            myChart.current && myChart.current.dispose();
            myChart.current && myChart.current.dispose();
            myChart.current = null;
        }
        catch (err) {
            console.log("Unload", new Date().toISOString(), JSON.stringify(err), err);
        }
    };
  }, [dataAnalysisInfo]);

  return <div ref={chartRef} style={{ width: "100%", height: "400px" }} />;
};
